import Link from 'next/link';
import React from 'react';
import howToTradeImg from '../../../assets/images/trade/how-to-trade.jpg';
import TradeButton from '../../../features/lottery/components/TradeButton/TradeButton';
import TradeNotes from '../../../features/lottery/components/TradeNote/TradeNote';
import type { LotteryTrade } from '../../../features/lottery/types';
import { Format } from '../../../lib/dateFns';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import { formatDateCommon } from '../../../utils/formatters';
import ImageView from '../ImageView/ImageView';
import styles from './TradeDetails.module.scss';

export type TradeDetailsProps = {
  item: LotteryTrade;
  lotteryId: string;
};

function TradeDetails({ item }: TradeDetailsProps) {
  return (
    <div className={`${styles.detailContainer} ${utilsStyles.mtMedium}`}>
      {/* 交換手順画像 */}
      <div className={styles.imagePlaceholder}>
        <section className={utilsStyles.mtSmall} id='howToTrade'>
          <ImageView src={howToTradeImg.src} isFreeSize />
        </section>
      </div>

      {/* 詳細セクション */}
      <div className={`${styles.section} ${utilsStyles.mtMedium}`}>
        <div className={styles.detailRow}>
          <p className={styles.label}>対象くじ</p>
          <p className={`${styles.value} ${utilsStyles.primaryColor}`}>{item.event.name}</p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.detailRow}>
          <p className={styles.label}>保有数</p>
          <p className={styles.value}>
            {item.goods.totalAcquiredCount} 個<br />
            <span className={`${styles.subText} ${utilsStyles.textXSmall}`}>
              くじ当選数 {item.goods.wonCount}個／交換済 {item.goods.outCount}個
            </span>
          </p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.detailRow}>
          <p className={styles.label}>交換可能景品数</p>
          <p className={styles.value}>
            {item.goods.tradeableCount} 個
            <br />
            <Link
              //@ts-ignore
              href='/faq?q=景品の交換とは'
              className={`${styles.linkText} ${utilsStyles.textXSmall} ${utilsStyles.textLink}`}
            >
              景品の交換とは？
            </Link>
          </p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.detailRow}>
          <p className={styles.label}>交換可能期間</p>
          <p className={`${styles.value} ${utilsStyles.primaryColor}`}>
            {formatDateCommon(item.event.tradeAt, Format.dateTimeLotteryJa)}まで
          </p>
        </div>
        <hr className={styles.divider} />
        <div className={styles.detailRow}>
          <p className={styles.label}>交換条件</p>
          <p className={styles.value}>
            同一種類の景品を『{item.goods.minTradeRequiredCount} 個』を選択（破棄）で、希望の景品を『1
            個』獲得できます。
          </p>
        </div>
      </div>
      <hr className={styles.divider} />

      {/* 注意事項セクション */}
      <TradeNotes tradeAt={item.event.tradeAt} />
      {/* ボタンセクション */}
      <div className={`${styles.buttonContainer} ${utilsStyles.mtLarge}`}>
        <TradeButton
          version='2.0'
          size='large'
          lotteryId={item.event.id}
          tradeableCount={item.goods.tradeableCount}
          minTradeRequiredCount={item.goods.minTradeRequiredCount}
          currentPage='tradeDetail'
        />
      </div>
    </div>
  );
}

export default TradeDetails;
